import { useQuery, UseQueryResult } from "react-query"
import CarrotClient from "lib/carrot-api"
import Settings from "utils/CarrotConfig"
import ResponseError from "utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { RoutingInfo } from "../../../types/RoutingInfo"
import { StatusCodes } from "http-status-codes"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENTITY = "RoutingInfo"

const loadData = async (employeeId: number): Promise<RoutingInfo> => {
  let routingInfo: RoutingInfo
  try {
    routingInfo = await client.getEmployeeRoutingInfo(employeeId)
  } catch (error) {
    if (error instanceof ResponseError && error.statusCode !== StatusCodes.NOT_FOUND) {
      throw error
    }
  }
  return routingInfo
}

export default function useRoutingInfo(employeeId: number): UseQueryResult<RoutingInfo, ResponseError> {
  return useQuery<RoutingInfo, ResponseError>([ENTITY, employeeId], () => loadData(employeeId), {
    ...RetryConfig
  })
}
